/* eslint-disable */
import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  dashboard: {
    id: 'menu.dashboard',
    description: 'Dashboard',
    defaultMessage: 'Dashboard',
  },
  settings: {
    id: 'menu.settings',
    description: 'Settings',
    defaultMessage: 'Settings',
  },
  shipments: {
    id: 'menu.shipments',
    description: 'Shipments',
    defaultMessage: 'Shipments',
  },
  locations: {
    id: 'menu.locations',
    description: 'Locations',
    defaultMessage: 'Locations',
  },
  journeys: {
    id: 'menu.journeys',
    description: 'Journeys side menu name',
    defaultMessage: 'Journeys',
  },
  customers: {
    id: 'menu.customer',
    description: 'Customer',
    defaultMessage: 'Customers',
  },
  invalidTenantError: {
    id: 'loginErrors.invalidTenantError',
    description: 'Error message indicates invalid tenant of the user',
    defaultMessage: 'Login Failed: No user account found!',
  },
  generalLoginError: {
    id: 'loginErrors.generalLoginError',
    description: 'Error message indicates unexpected error during sign in',
    defaultMessage: 'Login Failed!',
  },
  assetsManagement: {
    id: 'menu.assetsManagement',
    description: 'Assets Management',
    defaultMessage: 'Assets Management',
  },
  delete: {
    id: 'menu.delete',
    description: 'Delete',
    defaultMessage: 'Delete',
  },
  cancel: {
    id: 'menu.cancel',
    description: 'Cancel',
    defaultMessage: 'Cancel',
  },
  brandNameRequired: {
    id: 'brand.validation.nameRequired',
    description: 'Validation message for required brand name',
    defaultMessage: 'Name is required',
  },
  brandNameTooLong: {
    id: 'brand.validation.nameTooLong',
    description: 'Validation message for maximum brand name length',
    defaultMessage: 'Name must be 250 characters or less',
  },
})

export const productValidationMessages = defineMessages({
  positiveNumber: {
    id: 'product.validation.positiveNumber',
    description: 'Validation message for positive number',
    defaultMessage: 'Value must be a positive number',
  },
  documentExpiryRequired: {
    id: 'product.validation.documentExpiryRequired',
    description: 'Validation message for required document expiry date',
    defaultMessage: 'Document expiry date is required',
  },
  documentNameRequired: {
    id: 'product.validation.documentNameRequired',
    description: 'Validation message for required document name',
    defaultMessage: 'Document name is required',
  },
  currencyRequired: {
    id: 'product.validation.currencyRequired',
    description: 'Validation message for required currency',
    defaultMessage: 'Currency is required',
  },
  priceRequired: {
    id: 'product.validation.priceRequired',
    description: 'Validation message for required price',
    defaultMessage: 'Price is required',
  },
  priceMinimum: {
    id: 'product.validation.priceMinimum',
    description: 'Validation message for minimum price',
    defaultMessage: 'Price must be greater than 0',
  },
  priceMaximum: {
    id: 'product.validation.priceMaximum',
    description: 'Validation message for maximum price',
    defaultMessage: 'Price cannot exceed 9,999,999,999.99',
  },
  weightUnitRequired: {
    id: 'product.validation.weightUnitRequired',
    description: 'Validation message for required weight unit',
    defaultMessage: 'Weight unit is required when net weight is specified',
  },
  volumeUnitRequired: {
    id: 'product.validation.volumeUnitRequired',
    description: 'Validation message for required volume unit',
    defaultMessage: 'Volume unit is required when volume is specified',
  },
  lengthUnitRequired: {
    id: 'product.validation.lengthUnitRequired',
    description: 'Validation message for required length unit',
    defaultMessage: 'Length unit is required when dimensions are specified',
  },
  temperatureUnitRequired: {
    id: 'product.validation.temperatureUnitRequired',
    description: 'Validation message for required temperature unit',
    defaultMessage: 'Temperature unit is required when temperature thresholds are specified',
  },
  thresholdWarningComparison: {
    id: 'product.validation.thresholdWarningComparison',
    description: 'Validation message for warning threshold comparison',
    defaultMessage: 'Lower warning threshold must be less than or equal to upper warning threshold',
  },
  thresholdCriticalComparison: {
    id: 'product.validation.thresholdCriticalComparison',
    description: 'Validation message for critical threshold comparison',
    defaultMessage:
      'Lower critical threshold must be less than or equal to upper critical threshold',
  },
  temperatureRangeRequired: {
    id: 'product.validation.temperatureRangeRequired',
    description: 'Validation message for required temperature range',
    defaultMessage: 'Temperature range is required when temperature settings are specified',
  },
  setPointRequired: {
    id: 'product.validation.setPointRequired',
    description: 'Validation message for required set point',
    defaultMessage: 'Set point is required when temperature range is specified',
  },
  criticalThresholdsRequired: {
    id: 'product.validation.criticalThresholdsRequired',
    description: 'Validation message for required critical thresholds',
    defaultMessage: 'Critical thresholds are required when temperature range is specified',
  },
  lowerThresholdCriticalRequired: {
    id: 'product.validation.lowerThresholdCriticalRequired',
    description: 'Validation message for required lower critical threshold',
    defaultMessage: 'Lower Critical is required when temperature range is specified',
  },
  upperThresholdCriticalRequired: {
    id: 'product.validation.upperThresholdCriticalRequired',
    description: 'Validation message for required upper critical threshold',
    defaultMessage: 'Upper Critical is required when temperature range is specified',
  },
  setPointUpperCriticalComparison: {
    id: 'product.validation.setPointUpperCriticalComparison',
    description: 'Validation message for set point vs upper critical comparison',
    defaultMessage: 'Set Point cannot be more than Upper Critical',
  },
  setPointLowerCriticalComparison: {
    id: 'product.validation.setPointLowerCriticalComparison',
    description: 'Validation message for set point vs lower critical comparison',
    defaultMessage: 'Set Point cannot be less than Lower Critical',
  },
  upperCriticalSetPointComparison: {
    id: 'product.validation.upperCriticalSetPointComparison',
    description: 'Validation message for upper critical vs set point comparison',
    defaultMessage: 'Upper Critical cannot be lower than Set Point',
  },
  lowerCriticalSetPointComparison: {
    id: 'product.validation.lowerCriticalSetPointComparison',
    description: 'Validation message for lower critical vs set point comparison',
    defaultMessage: 'Lower Critical cannot be more than Set Point',
  },
  lowerWarningLowerCriticalComparison: {
    id: 'product.validation.lowerWarningLowerCriticalComparison',
    description: 'Validation message for lower warning vs lower critical comparison',
    defaultMessage: 'Lower Warning cannot be less than Lower Critical',
  },
  upperWarningUpperCriticalComparison: {
    id: 'product.validation.upperWarningUpperCriticalComparison',
    description: 'Validation message for upper warning vs upper critical comparison',
    defaultMessage: 'Upper Warning cannot be more than Upper Critical',
  },
  upperWarningSetPointComparison: {
    id: 'product.validation.upperWarningSetPointComparison',
    description: 'Validation message for upper warning vs set point comparison',
    defaultMessage: 'Upper Warning cannot be lower than Set Point',
  },
  nameRequired: {
    id: 'product.validation.nameRequired',
    description: 'Validation message for required product name',
    defaultMessage: 'Product name is required',
  },
  nameMaxLength: {
    id: 'product.validation.nameMaxLength',
    description: 'Validation message for maximum product name length',
    defaultMessage: 'Product name must be 250 characters or less',
  },
  customerRequired: {
    id: 'product.validation.customerRequired',
    description: 'Validation message for required customer',
    defaultMessage: 'Customer is required',
  },
  customerIdType: {
    id: 'product.validation.customerIdType',
    description: 'Validation message for customer ID type',
    defaultMessage: 'Customer ID must be a number',
  },
  skuRequired: {
    id: 'product.validation.skuRequired',
    description: 'Validation message for required SKU',
    defaultMessage: 'SKU is required',
  },
  skuMaxLength: {
    id: 'product.validation.skuMaxLength',
    description: 'Validation message for maximum SKU length',
    defaultMessage: 'SKU must be 50 characters or less',
  },
  skuFormat: {
    id: 'product.validation.skuFormat',
    description: 'Validation message for SKU format',
    defaultMessage:
      'SKU can only contain letters (A-Z, a-z), numbers (0-9), hyphens (-), underscores (_), periods (.), hash (#), and commas (,)',
  },
  productCategoryRequired: {
    id: 'product.validation.productCategoryRequired',
    description: 'Validation message for required product category',
    defaultMessage: 'Product Category is required',
  },
  productCategoryIdType: {
    id: 'product.validation.productCategoryIdType',
    description: 'Validation message for product category ID type',
    defaultMessage: 'Product Category ID must be a number',
  },
  countryOfOriginRequired: {
    id: 'product.validation.countryOfOriginRequired',
    description: 'Validation message for required country of origin',
    defaultMessage: 'Country of Origin is required',
  },
  countryOfOriginIdType: {
    id: 'product.validation.countryOfOriginIdType',
    description: 'Validation message for country of origin ID type',
    defaultMessage: 'Country of Origin ID must be a number',
  },
  barcodeMaxLength: {
    id: 'product.validation.barcodeMaxLength',
    description: 'Validation message for maximum barcode length',
    defaultMessage: 'Barcode must be 50 characters or less',
  },
  barcodeFormat: {
    id: 'product.validation.barcodeFormat',
    description: 'Validation message for barcode format',
    defaultMessage: 'Barcode can only contain Latin characters and numbers',
  },
  inventoryUnitRequired: {
    id: 'product.validation.inventoryUnitRequired',
    description: 'Validation message for required inventory unit',
    defaultMessage: 'Inventory Unit is required',
  },
  inventoryUnitIdType: {
    id: 'product.validation.inventoryUnitIdType',
    description: 'Validation message for inventory unit ID type',
    defaultMessage: 'Inventory Unit ID must be a number',
  },
  densityUnitsRequired: {
    id: 'product.validation.densityUnitsRequired',
    description: 'Validation message for required density units',
    defaultMessage: 'Density Units is required',
  },
  netWeightRequired: {
    id: 'product.validation.netWeightRequired',
    description: 'Validation message for required net weight',
    defaultMessage: 'Net Weight is required',
  },
  grossWeightRequired: {
    id: 'product.validation.grossWeightRequired',
    description: 'Validation message for required gross weight',
    defaultMessage: 'Gross Weight is required',
  },
  lengthRequired: {
    id: 'product.validation.lengthRequired',
    description: 'Validation message for required length',
    defaultMessage: 'Length is required',
  },
  widthRequired: {
    id: 'product.validation.widthRequired',
    description: 'Validation message for required width',
    defaultMessage: 'Width is required',
  },
  heightRequired: {
    id: 'product.validation.heightRequired',
    description: 'Validation message for required height',
    defaultMessage: 'Height is required',
  },
  diameterRequired: {
    id: 'product.validation.diameterRequired',
    description: 'Validation message for required diameter',
    defaultMessage: 'Diameter is required',
  },
  volumeRequired: {
    id: 'product.validation.volumeRequired',
    description: 'Validation message for required volume',
    defaultMessage: 'Volume is required',
  },
  densityRequired: {
    id: 'product.validation.densityRequired',
    description: 'Validation message for required density',
    defaultMessage: 'Density is required',
  },
})

export default messages
